import { render } from "./CabinmanReportDetails.vue?vue&type=template&id=0ef6b420&scoped=true"
import script from "./CabinmanReportDetails.vue?vue&type=script&lang=js"
export * from "./CabinmanReportDetails.vue?vue&type=script&lang=js"

import "./CabinmanReportDetails.vue?vue&type=style&index=0&id=0ef6b420&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef6b420"]])

export default __exports__